import { render, staticRenderFns } from "./offlineOrder.vue?vue&type=template&id=3967cfdb&"
import script from "./offlineOrder.vue?vue&type=script&lang=js&"
export * from "./offlineOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports